import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

// 네이버 · 구글에서 돌아온 뒤의 마무리 화면. 주소의 # 뒤에 실려 온 토큰으로 로그인 상태를 만든다.
const SocialLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token') || '';
    const err = params.get('error') || '';
    // 토큰이 주소창 · 방문 기록에 남지 않게 지운다
    window.history.replaceState(null, '', window.location.pathname);

    if (!token) {
      setError(err || '로그인하지 못했습니다');
      return;
    }

    loginWithToken(token).then(result => {
      if (!result.success) {
        setError(result.error || '로그인하지 못했습니다');
        return;
      }
      // 주문하다가 가입하러 온 경우 주문서로 되돌려 보낸다
      const after = sessionStorage.getItem('ws_after_login_order');
      if (after) {
        sessionStorage.removeItem('ws_after_login_order');
        try {
          navigate('/order', { state: JSON.parse(after), replace: true });
          return;
        } catch {}
      }
      navigate('/', { replace: true });
    });
  }, [loginWithToken, navigate]);

  return (
    <>
      <Header />
      <div className="auth-page">
        <div className="auth-card">
          <h2 className="auth-title">간편 로그인</h2>
          {error ? (
            <>
              <div className="auth-error">{error}</div>
              <div className="auth-footer">
                <Link to="/login">로그인 화면으로</Link>
              </div>
            </>
          ) : (
            <p className="auth-subtitle">로그인하는 중입니다...</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SocialLoginPage;
